<template>
  <div>
    <a
      data-toggle="dropdown"
      href="#"
      role="button"
      aria-haspopup="true"
      aria-expanded="false"
      class="nav-link activity-button activity-item dropdown-toggle"
      :class="currentActivity.class"
    >
      <span v-if="!loadingActivity" class="icon"></span>
      <span class="activity-status-name">
        {{ loadingActivity ? 'Loading..' : currentActivity.label }}
      </span>
    </a>

    <user-activity-options
      :current-status="currentActivity.status"
      :current-status-label="currentActivity.label"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex"
import UserActivityOptions from "./UserActivityOptions.vue"

export default {
  name: "Activity",
  components: {
    UserActivityOptions
  },
  props: {
    status: {
      type: String,
      default: "offline"
    },
    label: {
      type: String,
      default: "Inactive"
    },
    userId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState("activity", ["loadingActivity"]),
    ...mapGetters("activity", ["currentActivity"])
  },
  mounted() {
    this.setCurrentActivity([this.status, this.label])
    this.setUserId(this.userId)
  },
  methods: {
    ...mapActions("activity", ["setCurrentActivity", 'setUserId'])
  },
  watch: {
    status: function(value) {
      if (value !== 'busy') {
        this.setCurrentActivity([value])
      }
    },
    label: function(value) {
      if (value !== null) {
        this.setCurrentActivity([this.status, value])
      }
    }
  }
}
</script>